import Button from '@/shared/Buttons/Button'
import NotificationIcon from '../../../../assets/icons/notification.svg?react'
import { useRecoilValue } from 'recoil'
import userAtom from '@/pages/User/user.atom.ts'
import css from './notificationButton.module.css'

interface IProps {
  setOpen: (value: React.SetStateAction<boolean>) => void
}

const NotificationsButton = (props: IProps) => {
  const { isNotificationsViewed } = useRecoilValue(userAtom)

  const renderIcon = () => {
    if (isNotificationsViewed) return <NotificationIcon style={{ color: '' }} />
    return (
      <div className={css.iconContainer}>
        <NotificationIcon style={{ color: 'red' }} />
        <span className={css.unseenStatus}></span>
      </div>
    )
  }
  return <Button size="default" type="default" onClick={() => props.setOpen((prev) => !prev)} icon={renderIcon()} />
}

export default NotificationsButton
